"use client";
import { FC, useState } from "react";
import { Button, ButtonProps } from "@/components/Button";
import cn from "classnames";

type CopyTextButtonProps = (
  | ButtonProps
  | {
      className: (copied: boolean) => string;
    }
) & { text?: string };
export const CopyTextButton: FC<CopyTextButtonProps> = (props) => {
  const [copied, setCopied] = useState(false);

  const flashCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Button
      onClick={async () => {
        if (copied) {
          return;
        }
        const text = props.text ?? "";
        try {
          await navigator.clipboard.writeText(text);
          flashCopied();
        } catch {
          // Fallback for older browsers or non-secure contexts
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.setAttribute("readonly", "");
          ta.style.position = "absolute";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand("copy");
            flashCopied();
          } finally {
            document.body.removeChild(ta);
          }
        }
      }}
      {...(props as unknown as ButtonProps)}
      className={cn("ml-auto", { "opacity-50": copied }, props.className)}
    />
  );
};
